{
  "title": "Consultas",
  "subtitle": "Mensajes del formulario de contacto público y de Obtener ayuda dentro del portal.",
  "newCount": "{{count}} nuevas",
  "statusNew": "Nueva",
  "statusHandled": "Atendida",
  "statusSpam": "Spam",
  "loadError": "No se pudieron cargar las consultas",
  "goneTitle": "Esa consulta ya no existe",
  "goneBody": "El enlace apuntaba a una consulta que ya no está: puede haberse eliminado o la dirección estar mal escrita.",
  "emptyNewTitle": "Nada pendiente",
  "emptyNewBody": "Todo lo pendiente ya se ha atendido.",
  "emptyOtherTitle": "Nada aquí",
  "emptyOtherBody": "No hay consultas marcadas como {{status}}.",
  "handledBy": "atendida por {{name}}",
  "reply": "Responder",
  "markHandled": "Marcar como atendida",
  "markSpam": "Spam",
  "markNew": "Reabrir",
  "markedVerb": "{{name}} marcada como {{verb}}.",
  "updateError": "No se pudo actualizar esa consulta.",
  "replyTitle": "Responder a {{name}}",
  "replyBody": "Tu respuesta",
  "sendReply": "Enviar respuesta",
  "replySent": "Respuesta enviada a {{email}}.",
  "replyError": "No se pudo enviar esa respuesta.",
  "getHelp": "Obtener ayuda",
  "getHelpTitle": "Obtener ayuda",
  "getHelpHint": "Cuéntanos qué necesitas. El personal de OnBrand Mail responderá por correo.",
  "messageLabel": "Mensaje",
  "messagePlaceholder": "Qué estás intentando hacer y qué te lo impide.",
  "send": "Enviar",
  "helpSent": "Mensaje enviado. Responderemos por correo.",
  "helpRateLimited": "Varios mensajes en poco tiempo: inténtalo de nuevo en unos minutos.",
  "helpSendError": "No se pudo enviar. Inténtalo de nuevo.",
  "noAccessTitle": "Sin acceso a consultas",
  "noAccessBody": "Los mensajes del sitio público los lee el personal de OnBrand Mail.",
  "footerNote": "Las consultas llegan del formulario de contacto del sitio público y de Obtener ayuda en el portal. Los mensajes del sitio aún no son clientes: se crea un inquilino desde la pantalla Inquilinos cuando haya algo que incorporar. La ayuda del portal ya nombra la organización.",
  "replySendsFrom": "Se envía desde OnBrand Mail a {{email}}. Su respuesta vuelve a la bandeja de soporte.",
  "verbHandled": "gestionada",
  "verbSpam": "spam",
  "verbReopened": "nueva de nuevo"
}
